export default "__VITE_ASSET__DFPFw438__"